import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import withPageContainer from '../../shared/with-page-container';
import Animate from '../../shared/animation';
import Filters from '../../shared/filters/main';
import Calendar from '../../shared/calendar/main';
import Groups from '../../shared/groups/main';

import Switch from '../components/switch';
import Table from '../components/table/invalid/main';

import { selectors as rootSelectors } from '../../root';

import { enum as adminPermissions } from '../../../../../../enums/admin-permissions';

const Main = withPageContainer(props => (
	<Animate>
		<div className="container__content statistics">
			<div className="container__content-title">
				<div className="container__content-title-position border-hide">
					<h2 className="title">{props.intl('Statistics')}</h2>
				</div>
				<Switch {...props}/>
			</div>
			<div className="container__content-body">
				<div className="statistics__filter-position clearfix">
					<Filters
						// In future implement vertical-scroll container for each filter.
						overflow={[{
							name: 'affiliates',
							max: 10
						}]}
						{...props}
						{...props.filters}
					/>
				</div>

				<div className="ui-control-bar">
					<div className="ui-control-bar__item modify-item---groups">
						<div className="ui-control-bar__item-position">
							<Groups {...props} />
						</div>
					</div>
					<div className="ui-control-bar__item modify-item---calendar">
						<div className="ui-control-bar__item-position">
							<Calendar
								{...props.calendar}
								onInit={props.calendarInit}
								onToggle={props.calendarToggle}
								onChange={props.calendarChange}
								onApply={props.calendarApply}
								intl={props.intl}/>
						</div>
					</div>
					<div className="ui-control-bar__item">
						<div className="ui-control-bar__item-position">
							<button className="ui-btn ui-btn-primary apply" onClick={props.apply}>{props.intl('Apply')}</button>
							<button className="ui-btn ui-btn-secondary clear" onClick={props.clear} />
						</div>
					</div>
				</div>

				<div className="statistics__table-position">
					<Table
						{...props}
						isIndexing
					/>
				</div>
			</div>
		</div>
	</Animate>
), { permission: adminPermissions.analyticsView });

export default connect(
	state => ({
		data: selectors.getData(state),
		groupColumns: selectors.getGroupColumns(state),
		table: selectors.getTable(state),
		intl: selectors.getIntl(state),
		calendar: selectors.getCalendar(state),
		filters: selectors.getFilters(state),
		listOfCurrencies: selectors.getListOfCurrencies(state),
		currentCurrency: selectors.getCurrentCurrency(state),
		groupsSelectValues: selectors.getGroupsSelectValues(state),
		groupsSelectControls: selectors.getGroupsSelectControls(state),
		groupsSelectOptions: selectors.getGroupsSelectOptions(state),
		progressBar: selectors.getProgressBar(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		queryToConversionsSimple: selectors.getQueryToConversionsSimple(state),
		can: selectors.getCan(state),
		sort: selectors.getSort(state),
		conversionsFilterInitialValues: selectors.getConversionsFilterInitialValues(state),
		filterContextForSwitchControl: selectors.getFilterContext(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/invalid/main.js